import { round } from 'lodash';
import React from 'react';
import { NumberFormatProps } from 'react-number-format';
import EnhancedNumberFormat, { ClearBehaviour } from '../EnhancedNumberFormat/EnhancedNumberFormat';

interface Props {
    value: number;
    onChange(value: number): void;
}

export const MIN_SELL_THROUGH_PERCENTAGE = 1; // ensure > 0 to avoid division by zero errors
export const MAX_SELL_THROUGH_PERCENTAGE = 1000;

function SellThroughInput({ value, onChange, ...props }: Omit<NumberFormatProps, 'onChange'> & Props) {
    return (
        <EnhancedNumberFormat
            {...props}
            value={round(value * 100, 1)}
            suffix="%"
            decimalScale={0}
            step={MIN_SELL_THROUGH_PERCENTAGE}
            minimum={MIN_SELL_THROUGH_PERCENTAGE}
            maximum={MAX_SELL_THROUGH_PERCENTAGE}
            clearBehaviour={ClearBehaviour.RESET_LAST_VALUE}
            onChange={(newValue) => {
                if (newValue !== null && !Number.isNaN(newValue) && newValue > 0) {
                    onChange(round(newValue / 100, 2));
                }
            }}
        />
    );
}

export default SellThroughInput;
